import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"height":"100%"} }
const _hoisted_8 = {
  key: 0,
  class: "spin"
}
const _hoisted_9 = {
  key: 0,
  class: "top-badge ion-text-center",
  style: {"top":"0","width":"100%","height":"100%"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "top-badge"
}
const _hoisted_13 = {
  key: 1,
  class: "top-badge ion-text-center",
  style: {"top":"0","width":"100%","height":"100%"}
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { style: {"padding":"8px","width":"100%"} }
const _hoisted_16 = { style: {"padding-top":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_FDMTRiceCardSlide = _resolveComponent("FDMTRiceCardSlide")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_searchbar, {
                    id: "keyword-searchbar",
                    style: {"padding-bottom":"1px"},
                    mode: "md",
                    modelValue: _ctx.searchKeyword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKeyword) = $event)),
                    placeholder: _ctx.t('search'),
                    onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSearching = true)),
                    onIonBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchKeywordUpdated())),
                    onIonCancel: _cache[3] || (_cache[3] = ($event: any) => {_ctx.isSearching = false; _ctx.numOfVisibleItems = 20}),
                    onKeyup: _cache[4] || (_cache[4] = _withKeys((e) => e.target.blur(), ["enter"])),
                    "show-cancel-button": "always"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.isSearching]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.loadingData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.isSearching)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                  _createElementVNode("p", null, [
                                    _createElementVNode("b", null, "Select")
                                  ], -1)
                                ])),
                                _: 1,
                                __: [12]
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedProfessions().slice(0, _ctx.numOfVisibleItems), (profession) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              lines: "full",
                              key: profession.id,
                              style: {"--min-height":"55px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  labelPlacement: "end",
                                  "onUpdate:modelValue": ($event: any) => (_ctx.onCheckProfession($event, profession)),
                                  modelValue: _ctx.selectedItems.find(p => p.id == profession.id) != null
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_text, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("p", null, _toDisplayString(profession.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (profession.relatedSegments && profession.relatedSegments.length > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " In: " + _toDisplayString(profession.relatedSegments.map(s => s.name).join(", ")), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onUpdate:modelValue", "modelValue"]),
                                _createVNode(_component_ion_button, {
                                  onClick: ($event: any) => (_ctx.openProfessionModal(profession.id)),
                                  color: "medium",
                                  slot: "end",
                                  fill: "clear",
                                  size: "small",
                                  style: {"margin-inline-end":"16px","text-transform":"none"}
                                }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode(" More ")
                                  ])),
                                  _: 2,
                                  __: [13]
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_ion_infinite_scroll, {
                            onIonInfinite: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadData($event))),
                            threshold: "100px",
                            id: "infinite-scroll"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_infinite_scroll_content, {
                                "loading-spinner": "bubbles",
                                "loading-text": "Loading..."
                              })
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.recommendedProfessions().length > 0]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_4, _cache[14] || (_cache[14] = [
                          _createElementVNode("p", null, "No professions available", -1)
                        ]), 512), [
                          [_vShow, _ctx.recommendedProfessions().length == 0]
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.selectedFilterGroup == 'gpt')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _withDirectives(_createVNode(_component_FDMTRiceCardSlide, null, null, 512), [
                                [_vShow, _ctx.gpt.currStep == 1 && _ctx.botSuggestedProfessions.length == 0]
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_7, [
                                (_ctx.gpt.waitingGPTResp)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createVNode(_component_ion_spinner)
                                    ]))
                                  : (_openBlock(), _createBlock(_component_swiper, {
                                      key: 1,
                                      navigation: true,
                                      class: "card-slides",
                                      id: "card-swiper-slides",
                                      effect: 'cards',
                                      grabCursor: true,
                                      modules: _ctx.modules
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.botSuggestedProfessions, (profession) => {
                                          return (_openBlock(), _createBlock(_component_swiper_slide, {
                                            class: _normalizeClass(["card-slide", { 'highlighted-border': _ctx.isSelected(profession) }]),
                                            key: profession.id,
                                            "data-profession-id": profession.id
                                          }, {
                                            default: _withCtx(() => [
                                              (profession.imgLink && profession.imgLink != 'N/A')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createElementVNode("img", {
                                                      style: {"max-width":"100%","object-fit":"cover","height":"100%","filter":"brightness(60%)"},
                                                      src: profession.imgLink
                                                    }, null, 8, _hoisted_10)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_ion_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_col, {
                                                    size: "12",
                                                    style: {"text-shadow":"3px 3px 15px black"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("h1", null, [
                                                        _createTextVNode(_toDisplayString(profession.name), 1),
                                                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                                        _createElementVNode("small", null, _toDisplayString(profession.nameChinese), 1)
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _withDirectives(_createVNode(_component_ion_card, {
                                                class: "bottom-badge",
                                                style: {"margin-top":"0","border-radius":"16px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_item, { lines: "full" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", {
                                                                class: "trimmed-gpt-explanation",
                                                                innerHTML: _ctx.parseMsg(_ctx.currViewingProfession?.explanation)
                                                              }, null, 8, _hoisted_11)
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_ion_button, {
                                                            slot: "end",
                                                            size: "small",
                                                            color: "light",
                                                            class: "ion-no-margin no-text-transform",
                                                            onClick: ($event: any) => (_ctx.openProfessionModal(profession.id, _ctx.parseMsg(_ctx.currViewingProfession?.explanation)))
                                                          }, {
                                                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                              _createTextVNode(" More ")
                                                            ])),
                                                            _: 2,
                                                            __: [16]
                                                          }, 1032, ["onClick"])
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1536), [
                                                [_vShow, _ctx.currViewingProfession?.explanation]
                                              ]),
                                              _createVNode(_component_ion_fab, {
                                                slot: "fixed",
                                                vertical: "top",
                                                horizontal: "end"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_fab_button, _mergeProps(_toHandlers({ [_ctx.isMobileWeb() ? 'touchstart' : 'click']: () => { _ctx.onThumbsUp(profession, false) } }), {
                                                    style: {"--background":"transparent"},
                                                    color: profession.imgLink ? 'light' : undefined
                                                  }), {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        size: "large",
                                                        icon: _ctx.isSelected(profession) ? _ctx.thumbsUp : _ctx.thumbsUpOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1040, ["color"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["class", "data-profession-id"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modules"]))
                              ], 512), [
                                [_vShow, _ctx.botSuggestedProfessions.length > 0 || _ctx.gpt.currStep == 2]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              style: {"height":"100%"},
                              class: _normalizeClass({ 'valign': !_ctx.isSearching })
                            }, [
                              (!_ctx.delayLoading && _ctx.recommendedProfessions().length > 0)
                                ? (_openBlock(), _createBlock(_component_swiper, {
                                    key: 0,
                                    navigation: !_ctx.isMobileWeb(),
                                    class: "card-slides",
                                    id: "card-swiper-slides",
                                    effect: 'cards',
                                    grabCursor: true,
                                    modules: _ctx.modules
                                  }, {
                                    default: _withCtx(() => [
                                      ((_ctx.startIdx+1)-10 > 0)
                                        ? (_openBlock(), _createBlock(_component_swiper_slide, {
                                            key: 0,
                                            class: "card-slide",
                                            style: {"background-color":"var(--ion-color-light)"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_col, { size: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_button, _mergeProps({
                                                        size: "large",
                                                        color: "primary",
                                                        class: "no-text-transform",
                                                        fill: "outline"
                                                      }, _toHandlers({ [_ctx.isMobileWeb() ? 'touchstart' : 'click']: () => { _ctx.onClickPrevBtn() } })), {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_icon, {
                                                            slot: "end",
                                                            icon: _ctx.arrowBack
                                                          }, null, 8, ["icon"]),
                                                          _cache[17] || (_cache[17] = _createTextVNode(" Previous "))
                                                        ]),
                                                        _: 1,
                                                        __: [17]
                                                      }, 16)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedProfessions().slice(_ctx.startIdx, _ctx.startIdx+10), (item) => {
                                        return (_openBlock(), _createBlock(_component_swiper_slide, {
                                          class: _normalizeClass(["card-slide", { 'highlighted-border': _ctx.isSelected(item) }]),
                                          key: item.id,
                                          "data-item-id": item.id
                                        }, {
                                          default: _withCtx(() => [
                                            (['like','dislike'].includes(_ctx.selectedFilterGroup) && _ctx.getAppStateText(item.id))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                  _createVNode(_component_ion_chip, { class: "small-chip" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.getAppStateText(item.id)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (item.imgLink && item.imgLink != 'N/A')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                  _createElementVNode("img", {
                                                    style: {"max-width":"100%","object-fit":"cover","height":"100%","filter":"brightness(60%)"},
                                                    src: item.imgLink
                                                  }, null, 8, _hoisted_14)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ion_row, { style: {"text-shadow":"3px 3px 3px black"} }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_col, { size: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h1", null, [
                                                      _createTextVNode(_toDisplayString(item.name), 1),
                                                      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                                      _createElementVNode("small", null, _toDisplayString(item.nameChinese), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_ion_col, { size: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_button, {
                                                      size: "small",
                                                      color: "light",
                                                      class: "no-text-transform",
                                                      onClick: ($event: any) => (_ctx.openProfessionModal(item.id))
                                                    }, {
                                                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                        _createTextVNode(" Details ")
                                                      ])),
                                                      _: 2,
                                                      __: [19]
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_fab, {
                                              slot: "fixed",
                                              vertical: "top",
                                              horizontal: "end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_fab_button, _mergeProps(_toHandlers({ [_ctx.isMobileWeb() ? 'touchstart' : 'click']: () => { _ctx.onThumbsUp(item) } }), {
                                                  style: {"--background":"transparent"},
                                                  color: item.imgLink ? 'light' : undefined
                                                }), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      size: "large",
                                                      icon: _ctx.isSelected(item) ? _ctx.thumbsUp : _ctx.thumbsUpOutline
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 2
                                                }, 1040, ["color"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["class", "data-item-id"]))
                                      }), 128)),
                                      (_ctx.startIdx+10 < _ctx.recommendedProfessions().length)
                                        ? (_openBlock(), _createBlock(_component_swiper_slide, {
                                            key: 1,
                                            class: "card-slide",
                                            style: {"background-color":"var(--ion-color-light)"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_col, { size: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_button, _mergeProps({
                                                        size: "large",
                                                        color: "primary",
                                                        class: "no-text-transform",
                                                        fill: "outline"
                                                      }, _toHandlers({ [_ctx.isMobileWeb() ? 'touchstart' : 'click']: () => { _ctx.onClickMoreBtn() } })), {
                                                        default: _withCtx(() => [
                                                          _cache[20] || (_cache[20] = _createTextVNode(" More ")),
                                                          _createVNode(_component_ion_icon, {
                                                            slot: "end",
                                                            icon: _ctx.arrowForward
                                                          }, null, 8, ["icon"])
                                                        ]),
                                                        _: 1,
                                                        __: [20]
                                                      }, 16)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["navigation", "modules"]))
                                : _createCommentVNode("", true)
                            ], 2))
                      ]))
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--min-height":"24px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        class: "nav-category-btn",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmSelect(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            size: "small",
                            slot: "icon-only",
                            icon: _ctx.arrowBack
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment, {
                    class: "filter-group-segment",
                    mode: "ios",
                    modelValue: _ctx.selectedFilterGroup,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedFilterGroup) = $event)),
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, { value: "gpt" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("AI")
                            ])),
                            _: 1,
                            __: [21]
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_ion_segment_button, {
                          key: q.id,
                          value: q.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(q.group), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"])), [
                          [_vShow, _ctx.userRelatedJobEX['Show question tabs next to AI?'] == 'Y']
                        ])
                      }), 128)),
                      (_ctx.getAlumniProfessions().length > 0)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 0,
                            value: "alumni"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_ripple_effect),
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode("Alumni")
                                ])),
                                _: 1,
                                __: [22]
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.userItems.some(up => up.reaction == 'like'))
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 1,
                            value: "like"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                size: "small",
                                icon: _ctx.thumbsUpOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_segment_button, { value: "search" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_ripple_effect),
                          _createVNode(_component_ion_icon, {
                            size: "small",
                            icon: _ctx.search
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, { value: "sectors" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_ripple_effect),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode("Sectors")
                            ])),
                            _: 1,
                            __: [23]
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.user.isAdmin)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 2,
                            value: "video-taking"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_ripple_effect),
                              _createVNode(_component_ion_icon, {
                                size: "small",
                                icon: _ctx.ellipsisVertical
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_toolbar, { class: "material-div" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: q.id
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.options, (tab) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                              key: tab.id,
                              class: _normalizeClass({ 'active-tag': _ctx.selectedOption.id == tab.id }),
                              onClick: ($event: any) => (_ctx.selectedOption = tab)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tab.text), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"])), [
                              [_vShow, _ctx.selectedFilterGroup == q.id.toString()]
                            ])
                          }), 128))
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.selectedFilterGroup != 'gpt']
                  ]),
                  _withDirectives(_createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap ion-no-margin" }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createElementVNode("p", { style: {"line-height":"1"} }, [
                                _createElementVNode("small", null, "Disclaimer: The data presented is for reference purposes only. We do not guarantee their correctness, completeness, or timeliness.")
                              ], -1)
                            ])),
                            _: 1,
                            __: [24]
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_ion_textarea, {
                          placeholder: "By writing and/or tags, describe your strengths, passions, and habits as specifically as possible",
                          fill: "outline",
                          modelValue: _ctx.gpt.userInputText,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gpt.userInputText) = $event)),
                          rows: 3,
                          "auto-grow": true
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_ion_toolbar, { style: {"--min-height":"28px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_segment, {
                            class: "filter-group-segment",
                            mode: "ios",
                            modelValue: _ctx.gpt.selectedTagGroup,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.gpt.selectedTagGroup) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_segment_button, { value: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createTextVNode("All")
                                    ])),
                                    _: 1,
                                    __: [25]
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_segment_button, { value: "courses" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode("Courses")
                                    ])),
                                    _: 1,
                                    __: [26]
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_segment_button, { value: "suggested" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createTextVNode("Suggested")
                                    ])),
                                    _: 1,
                                    __: [27]
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_segment_button, { value: "general" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                                      _createTextVNode("General")
                                    ])),
                                    _: 1,
                                    __: [28]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: q.id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.options, (tag) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: tag.id,
                                onClick: ($event: any) => (_ctx.toggleSelectedTag(tag.id, tag.text)),
                                class: _normalizeClass({ 'active-tag': _ctx.gpt.tagId == tag.id })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag.text), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "class"])), [
                                [_vShow, !_ctx.gpt.selectedTagGroup || _ctx.gpt.selectedTagGroup == 'suggested']
                              ])
                            }), 128))
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passionTags, (tag, i) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                            key: i,
                            onClick: ($event: any) => (_ctx.toggleSelectedTag(tag.id, tag.text)),
                            class: _normalizeClass({ 'active-tag': _ctx.gpt.tagId == tag.id })
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tag.text), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "class"])), [
                            [_vShow, !_ctx.gpt.selectedTagGroup || _ctx.gpt.selectedTagGroup == 'general']
                          ])
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCourseOptions(), (tag, i) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                            key: i,
                            onClick: ($event: any) => (_ctx.toggleSelectedTag(tag.id, tag.text)),
                            class: _normalizeClass({ 'active-tag': _ctx.gpt.tagId == tag.id })
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tag.text), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "class"])), [
                            [_vShow, !_ctx.gpt.selectedTagGroup || _ctx.gpt.selectedTagGroup == 'courses']
                          ])
                        }), 128)),
                        _createVNode(_component_ion_chip, {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleSelectedTag(_ctx.tagObjOther.id, _ctx.tagObjOther.text))),
                          class: _normalizeClass({ 'active-tag': _ctx.gpt.tagId == _ctx.tagObjOther.id })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.tagObjOther.text), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.selectedFilterGroup == 'gpt']
                  ])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            expand: "block",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.gpt.currStep = 2; _ctx.getRecommendedProfessionsFromGPT()}),
                            disabled: (!_ctx.gpt.tagId && !_ctx.gpt.userInputText) || _ctx.gpt.isInCooldownTime,
                            class: "no-text-transform"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.gpt.isInCooldownTime ? `Please wait (${_ctx.gpt.cooldownSecLeft}s)` : `GO`) + " ", 1),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.arrowForward
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.selectedFilterGroup == 'gpt']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.loadingData && !_ctx.isSearching]
      ])
    ]),
    _: 1
  }))
}